import { render, staticRenderFns } from "./digitalDocente.vue?vue&type=template&id=cadfdade"
import script from "./digitalDocente.vue?vue&type=script&lang=js"
export * from "./digitalDocente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports